import { Tab } from "@mui/material"
import { styled } from "@mui/material/styles"

export const SbTab = styled(Tab)(({theme}) => ({
	"&": {
		textTransform: "none",
		fontWeight: "bold",
		color: "#cccccc",
	}
}))
